import React from "react";
import { profile } from "../../data/portfolio";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-neutral-900 py-10 md:py-14"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="inline-block w-1.5 h-1.5 bg-neutral-400" />
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-500">
            {profile.initials} — {profile.role}
          </span>
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-600">
          © {year} {profile.name}. Built with intent.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
